const ARRIVAL_DAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];

const ARRIVAL_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;

export const normalizeArrivalDateValue = (value?: string | null) => {
  const trimmedValue = value?.trim();
  if (!trimmedValue) {
    return '';
  }

  const match = trimmedValue.match(ARRIVAL_DATE_REGEX);
  if (!match) {
    return '';
  }

  const [, yearText, monthText, dayText] = match;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const date = new Date(year, month - 1, day, 12);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return '';
  }

  return `${yearText}-${monthText}-${dayText}`;
};

export const sortArrivalDateValues = (values?: string[] | null) =>
  Array.from(
    new Set(
      (values || [])
        .map((value) => normalizeArrivalDateValue(value))
        .filter(Boolean),
    ),
  ).sort((a, b) => a.localeCompare(b));

export const formatArrivalDateLabel = (value?: string | null) => {
  const normalizedValue = normalizeArrivalDateValue(value);
  if (!normalizedValue) {
    return '';
  }

  const [yearText, monthText, dayText] = normalizedValue.split('-');
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const date = new Date(year, month - 1, day, 12);

  return `${month}월 ${day}일 (${ARRIVAL_DAY_LABELS[date.getDay()]})`;
};
